import { useTranslation } from 'react-i18next';

export default function Services() {
  const { i18n } = useTranslation();

  const services = [
    {
      icon: 'ri-search-2-line',
      titleEn: 'Finding reliable suppliers/buyers',
      titleAr: 'العثور على موردين/مشترين موثوقين',
      descEn: 'Comprehensive supplier and buyer identification through our extensive global network and rigorous vetting processes.',
      descAr: 'تحديد شامل للموردين والمشترين من خلال شبكتنا العالمية الواسعة وعمليات الفحص الصارمة.'
    },
    {
      icon: 'ri-price-tag-3-line',
      titleEn: 'Negotiating the best commercial terms',
      titleAr: 'التفاوض على أفضل الشروط التجارية',
      descEn: 'Expert negotiation services to secure optimal pricing, favorable payment terms, and delivery conditions that benefit all parties.',
      descAr: 'خدمات تفاوض خبيرة لتأمين أفضل الأسعار وشروط الدفع المواتية وظروف التسليم التي تفيد جميع الأطراف.'
    },
    {
      icon: 'ri-file-text-line',
      titleEn: 'Preparing contracts and monitoring their implementation',
      titleAr: 'إعداد العقود ومراقبة تنفيذها',
      descEn: 'Comprehensive contract preparation and ongoing monitoring to ensure all terms are met and implemented correctly.',
      descAr: 'إعداد عقود شامل ومراقبة مستمرة لضمان الوفاء بجميع الشروط وتنفيذها بشكل صحيح.'
    },
    {
      icon: 'ri-bar-chart-line',
      titleEn: 'Providing business and market consulting',
      titleAr: 'تقديم الاستشارات التجارية والسوقية',
      descEn: 'Strategic business consulting and market analysis to help clients make informed decisions and identify new opportunities.',
      descAr: 'استشارات تجارية استراتيجية وتحليل السوق لمساعدة العملاء على اتخاذ قرارات مدروسة وتحديد فرص جديدة.'
    },
    {
      icon: 'ri-ship-line',
      titleEn: 'Facilitating shipping and customs clearance',
      titleAr: 'تسهيل الشحن والتخليص الجمركي',
      descEn: 'Complete logistics coordination including shipping arrangements, customs documentation, and clearance procedures.',
      descAr: 'تنسيق لوجستي كامل بما في ذلك ترتيبات الشحن والوثائق الجمركية وإجراءات التخليص.'
    },
    {
      icon: 'ri-building-line',
      titleEn: 'Setting up companies, facilitating banking transactions and opening accounts, finding investors',
      titleAr: 'تأسيس الشركات وتسهيل المعاملات المصرفية وفتح الحسابات والعثور على المستثمرين',
      descEn: 'Complete business setup services including company registration, banking facilitation, account opening, and investor matchmaking.',
      descAr: 'خدمات تأسيس الأعمال الكاملة بما في ذلك تسجيل الشركات وتسهيل الخدمات المصرفية وفتح الحسابات والتوفيق بين المستثمرين.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <i className="ri-service-line text-2xl text-[#D4AF37]"></i>
            <span className="text-sm font-medium text-[#1A5F7A] uppercase tracking-wider">
              {i18n.language === 'ar' ? 'خدماتنا المتخصصة' : 'Our Specialized Services'}
            </span>
          </div>
          <h2 className="text-5xl font-bold mb-6 leading-tight">
            <div className="text-[#0A2647]">
              {i18n.language === 'ar' ? 'حلول تجارية' : 'Commercial Solutions'}
            </div>
            <div className="bg-gradient-to-r from-[#1A5F7A] to-[#D4AF37] bg-clip-text text-transparent">
              {i18n.language === 'ar' ? 'شاملة ومتكاملة' : 'Tailored for Success'}
            </div>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {i18n.language === 'ar'
              ? 'نقدم خدمات الوساطة التجارية الشاملة من قلب الدوحة، مع التركيز على الجودة والشفافية والنتائج المثبتة'
              : 'Comprehensive commercial brokerage services from the heart of Doha, focusing on quality, transparency, and proven results'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#D4AF37]/30 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#1A5F7A] to-[#D4AF37] rounded-2xl mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-[#0A2647] mb-4 leading-snug">
                {i18n.language === 'ar' ? service.titleAr : service.titleEn}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {i18n.language === 'ar' ? service.descAr : service.descEn}
              </p>
              
              <div className="mt-6 pt-6 border-t border-gray-100">
                <a
                  href="#contact"
                  className="text-[#1A5F7A] font-medium hover:text-[#D4AF37] transition-colors cursor-pointer flex items-center gap-2 group"
                >
                  {i18n.language === 'ar' ? 'اعرف المزيد' : 'Learn More'}
                  <i className={`ri-arrow-${i18n.language === 'ar' ? 'left' : 'right'}-line group-hover:translate-x-1 transition-transform`}></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-[#1A5F7A] to-[#0A2647] rounded-3xl p-12 text-white relative overflow-hidden">
            <div className="absolute inset-0 bg-black/20"></div>
            <div className="relative z-10">
              <h3 className="text-3xl font-bold mb-4 leading-tight">
                {i18n.language === 'ar' ? 'هل أنت مستعد لتوسيع تجارتك؟' : 'Ready to Expand Your Trade?'}
              </h3>
              <p className="text-lg opacity-90 mb-8 max-w-2xl mx-auto">
                {i18n.language === 'ar'
                  ? 'دعنا نساعدك في الوصول إلى أسواق جديدة وتأمين شراكات تجارية مربحة'
                  : 'Let us help you access new markets and secure profitable trade partnerships'}
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-[#0A2647] rounded-full font-bold hover:bg-white transition-all cursor-pointer whitespace-nowrap"
              >
                {i18n.language === 'ar' ? 'ابدأ رحلتك معنا' : 'Start Your Journey'}
                <i className={`ri-arrow-${i18n.language === 'ar' ? 'left' : 'right'}-line`}></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
